import React, { useState } from 'react'
import { FaRegCopy } from 'react-icons/fa'

export const CopyToClipboard = ({ text }: { text: string }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }
  
  return (
    <div className="container-md text-muted  bg-body-tertiary shadow-sm">
      <div className="d-flex align-items-center ps-1 py-3">
        <span className="fw-bold">Loan ID:</span>
        <i className="ps-3">{text}</i>
        <div className="position-relative d-inline-flex align-items-center">
          <button
            type="button"
            className="btn p-0 border-0 text-muted"
            aria-label="Copy loan ID"
            onClick={handleCopy}
          > <FaRegCopy className="ms-2 pointer" /></button>
          {copied && (
            <span
              className="small px-2 py-1 copy-to-clipboard" aria-live="polite">
              Copied!
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
